import { RefreshCw } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

/** تحميل/خطأ لصفحات المحتوى (أول زيارة بس — بعدها بتتعرض من الكاش فوراً) */
const PageState = ({ page }) => {
  if (page.failed) {
    return (
      <div className="py-24 text-center font-cairo">
        <p className="text-gray-600 dark:text-gray-400 mb-4">تعذّر تحميل الصفحة.</p>
        <button
          type="button"
          onClick={page.reload}
          className="inline-flex items-center gap-2 bg-burgundy-500 hover:bg-burgundy-600 text-white font-semibold px-5 py-2.5 rounded-lg transition"
        >
          <RefreshCw className="w-4 h-4" />
          إعادة المحاولة
        </button>
      </div>
    );
  }

  return (
    <div className="py-12">
      <div className="container mx-auto px-4 max-w-[900px] space-y-6">
        <Skeleton className="h-12 w-2/3 mx-auto" />
        <Skeleton className="h-5 w-1/2 mx-auto" />
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} className="h-40 w-full rounded-lg" />
        ))}
      </div>
    </div>
  );
};

export default PageState;
